import { z } from "zod";

import { BaseForm, FormSelect, FormTextarea } from "components/BaseForm";

const TYPE_OPTIONS = [
  { key: "single", value: "single", text: "Single" },
  { key: "multi", value: "multi", text: "Multiple" },
];

const schema = z.object({
  type: z.string().min(1, "Type is required"),
  options: z.string().min(1, "Options are required"),
});

const CategoricalTypeOptionsForm = ({ fieldOptions, onSuccess, onCancel }) => {
  const handleSubmit = ({ type, options }) => {
    const parsed = options
      .split(",")
      .map(option => option.trim())
      .filter(Boolean);
    onSuccess({ name: "field_options", value: { type, options: parsed } });
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={{
        type: fieldOptions?.type ?? "single",
        options: Array.isArray(fieldOptions?.options)
          ? fieldOptions.options.join(", ")
          : (fieldOptions?.options ?? ""),
      }}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitButtonText="Save"
    >
      <FormSelect
        name="type"
        label="Select Type"
        required
        options={TYPE_OPTIONS}
      />
      <FormTextarea
        name="options"
        label="Field Options"
        required
        placeholder="add your options as a comma separated value ex:(1,apple,blue)"
      />
    </BaseForm>
  );
};

export default CategoricalTypeOptionsForm;
